// button tools
export const SELECT_TOOL_NAME = "SELECT";
export const ADJUST_SCALE_TOOL_NAME = "ADJUST_SCALE";
export const ROTATE_TOOL_NAME = "ROTATE_TOOL_NAME";

// non-button tools
export const PAN_TOOL_NAME = "PAN";
export const ARC_TOOL_NAME = "ARC";
export const ADD_BOUNDARY_TOOL_NAME = "ADD_BOUNDARY";
export const ADD_OBJECT_TOOL_NAME = "ADD_OBJECT";

// boundary tools
export const DIMENSION_LINE_TOOL_NAME = "dimension-line";
export const WALL_BOUNDARY_TOOL_NAME = "wall";
export const AIR_WALL_BOUNDARY_TOOL_NAME = "air-wall";
export const RAILING_BOUNDARY_TOOL_NAME = "railing";
export const BORDER_BOUNDARY_TOOL_NAME = "border";
export const STAIRS_BOUNDARY_TOOL_NAME = "stairs";

// object tools
export const DOOR_OBJECT_TOOL_NAME = "door";
export const DOUBLE_DOOR_OBJECT_TOOL_NAME = "double-door";
export const ROUND_COLUMN_OBJECT_TOOL_NAME = "round-column";
export const SQUARE_COLUMN_OBJECT_TOOL_NAME = "column";
export const ELECTRICAL_OUTLET_OBJECT_TOOL_NAME = "electric-outlet";
export const WINDOW_OBJECT_TOOL_NAME = "window";
export const RIGGING_OBJECT_TOOL_NAME = "rigging";
